import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaiDatGiaTriControl = _resolveComponent("CaiDatGiaTriControl")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_FormModalShell = _resolveComponent("FormModalShell")!

  return (_openBlock(), _createBlock(_component_FormModalShell, {
    "is-display": _ctx.isOpen,
    title: "Cập nhật cài đặt",
    size: "lg",
    width: "520px",
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.CANCEL,
        "color-type": _ctx.ButtonTypeColors.SECONDARY,
        "is-disabled": _ctx.saving,
        onClick: _ctx.onClose
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode("Huỷ")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "is-disabled", "onClick"]),
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.SAVE,
        "color-type": _ctx.ButtonTypeColors.SUCCESS,
        "is-loading": _ctx.saving,
        "is-disabled": _ctx.saving,
        onClick: _ctx.submit
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode("Lưu")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "is-loading", "is-disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.item)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _createTextVNode(" Khóa: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.khoa), 1),
            _createTextVNode(" · Kiểu: " + _toDisplayString(_ctx.loaiGiaTriLabel(_ctx.item.loai_gia_tri)), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Giá trị",
            prop: "gia_tri"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CaiDatGiaTriControl, {
                modelValue: _ctx.form.gia_tri,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.gia_tri) = $event)),
                "loai-gia-tri": _ctx.item?.loai_gia_tri || 'text',
                "tuy-chon": _ctx.item?.tuy_chon || [],
                placeholder: "Giá trị"
              }, null, 8, ["modelValue", "loai-gia-tri", "tuy-chon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Ghi chú",
            prop: "ghi_chu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.ghi_chu,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.ghi_chu) = $event)),
                type: "textarea",
                rows: 2,
                placeholder: "Ghi chú (tuỳ chọn)"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["is-display", "onClose"]))
}